
import type { SVGProps } from 'react';
const SvgPrint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#print_svg__a)">
      <path
        fill="#263E6A"
        d="M16 8.615v-3H8v3H7v-4h10v4zm1.615 3.5q.425 0 .713-.287a.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712q0 .426.288.713.288.288.712.287M16 19v-4.539H8V19zm1 1H7v-4H3.577v-5.385q0-.849.577-1.425a1.94 1.94 0 0 1 1.423-.575h12.846q.85 0 1.425.575.575.576.575 1.425V16H17zm2.423-5v-4.385a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288H5.577a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712V15H7v-1.539h10V15z"
      />
    </g>
    <defs>
      <clipPath id="print_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPrint;
